import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import Decimal from './break_infinity';
import global_css from './global-css';
import {formatEng} from './utils';

@customElement('smooth-value')
export class SmoothValue extends LitElement {
  timer: NodeJS.Timer;
  baseValue = new Decimal(0);
  get value() {
    return this.baseValue;
  }
  set value(val: Decimal) {
    this.target = val;
    const frames = 100;
    this.step = this.target.minus(this.baseValue).div(frames);
    this._count += frames;
  }
  private _count = 0;
  step = new Decimal(1);
  target = new Decimal(0);
  places = 1;
  get formattedValue() {
    return formatEng(this.value, this.places);
  }

  static override styles = [
    global_css,
    css`
      progress {
        width: 100%;
      }
    `,
  ];

  constructor() {
    super();
    this.timer = setInterval(() => {
      if (this._count > 0) {
        this._count -= 1;
        this.baseValue = this.baseValue.plus(this.step);
        this.requestUpdate();
      }
    }, 10);
  }

  override render() {
    return html`${this.formattedValue}`;
  }
}
